import React, { useRef, useEffect, useState } from "react"
import styles from "./styles"
import { withStyles } from "@material-ui/core/styles"
import { Formik, Form } from "formik"
import { Slider, Box, Typography, Checkbox } from "@material-ui/core/"
import ReusableFormControl from "components/ReusableFormControl"
import { useDebounce } from "use-lodash-debounce"
import { openSnackBar } from "actions/snack-bar"
import { useDispatch } from "react-redux"
import { checkGroupCode } from "actions/organization"
import MaskedOrganizationCode from "components/MaskedOrganizationCode"
const Step3OrganizationSize = ({ classes, options, data }) => {
  const [validGroupCode, setValidGroupCode] = useState(false)
  const { setFormRef, formSubmit, setFormData, formState } = data
  const dispatch = useDispatch()
  const formRef = useRef()
  const bouncedGroupCode = useDebounce(formState.groupCode, 200)
  const [checked, setChecked] = useState(false)

  const handleChangeChecked = () => {
    setChecked(!checked)
  }

  const changesValuesSlider = (value, fromWhere) => {
    const parent = document.getElementById(fromWhere)
    const elements = Array.from(parent.children).filter(x => x.innerHTML)
    const selected = options.find(x => x.id === value)
    const selectedElem = elements.find(x => x.innerHTML === selected.label)
    elements.map(x => {
      x.classList.remove(classes.activeSlider)
    })
    selectedElem.classList.add(classes.activeSlider)

    setFormData({
      target: {
        value: value,
        name: "plan"
      }
    })
  }
  useEffect(() => {
    setFormRef(formRef)
    changesValuesSlider(formState.plan, "sliderDesktop")
    changesValuesSlider(formState.plan, "sliderPhone")
  }, [])

  useEffect(() => {
    setValidGroupCode(false)
    dispatch(checkGroupCode(formState.groupCode))
      .then(res => {
        setValidGroupCode(true)
        setFormData({
          target: {
            name: "groupCodeId",
            value: res.result[0].id
          }
        })
      })
      .catch(err => {
        setValidGroupCode(false)
        setFormData({
          target: {
            name: "groupCodeId",
            value: 0
          }
        })
        console.log(err)
      })
  }, [bouncedGroupCode])
  useEffect(() => {
    if (formState.groupCode) {
      setChecked(true)
    }
  }, [])

  return (
    <Formik
      innerRef={formRef}
      initialValues={{
        plan: formState.plan,
        groupCode: formState.groupCode
      }}
      onSubmit={e => {
        if (!validGroupCode && formState.groupCode) {
          dispatch(openSnackBar({ message: "Invalid Group Code" }))
        } else {
          formSubmit(e)
        }
      }}
    >
      {formikProps => {
        const handleChange = formikProps.handleChange
        formikProps.handleChange = e => {
          handleChange(e)
          setFormData(e)
        }
        return (
          <Form ref={formRef}>
            <Typography
              variant="body1"
              className={classes.organizationExplanation}
            >
              How many members do you estimate are in your entire organization?
              This will tell us how many members can create an account within
              your organization.
            </Typography>
            <Box className={classes.groupCodeContainer}>
              <Typography variant="h6" color="primary">
                Have a group code?
              </Typography>
              <Checkbox
                checked={checked}
                onChange={handleChangeChecked}
                color="primary"
              />
              {checked && (
                <Box style={{ maxWidth: "200px", marginTop: "-16px" }}>
                  <ReusableFormControl
                    name="groupCode"
                    label="Group Code"
                    formikProps={formikProps}
                    inputClass={classes.inputReusableFormControl}
                    inputLabelClass={classes.labelTextColor}
                    inputProps={{
                      fullWidth: false,
                      inputComponent: MaskedOrganizationCode
                    }}
                  />
                </Box>
              )}
            </Box>
            <Box>
              <Typography
                variant="h6"
                color="primary"
                className={classes.organizationSizeTitle}
              >
                Total organization size
              </Typography>
              <Box
                className={classes.sliderDesktop}
                style={{ height: "200px" }}
              >
                <Slider
                  id="sliderDesktop"
                  key={options.id}
                  value={formState.plan}
                  aria-labelledby="discrete-slider-restrict"
                  step={null}
                  marks={options}
                  //changing max to options.length to account for any new plans
                  max={options.length}
                  min={1}
                  track="false"
                  valueLabelDisplay="off"
                  // onChange={(e, value) => {
                  //   const parent = document.getElementById("sliderDesktop")
                  //   const elements = Array.from(parent.children).filter(
                  //     x => x.innerHTML
                  //   )
                  //   const selected = options.find(x => x.id === value)
                  //   const selectedElem = elements.find(
                  //     x => x.innerHTML === selected.label
                  //   )

                  //   elements.map(x => {
                  //     x.classList.remove(classes.activeSlider)
                  //   })
                  //   selectedElem.classList.add(classes.activeSlider)

                  //   setFormData({
                  //     target: {
                  //       value: value,
                  //       name: "plan"
                  //     }
                  //   })
                  // }}
                  onChange={(e, val) =>
                    changesValuesSlider(val, "sliderDesktop")
                  }
                />
              </Box>
              <Box className={classes.sliderPhone} style={{ height: "200px" }}>
                <Slider
                  id="sliderPhone"
                  orientation="vertical"
                  key={options.id}
                  value={formState.plan}
                  aria-labelledby="discrete-slider-restrict"
                  step={null}
                  marks={options}
                  max={options.length}
                  min={1}
                  track="false"
                  valueLabelDisplay="off"
                  classes={{
                    markLabel: classes.markLabel,
                    rail: classes.rail,
                    mark: classes.mark,
                    thumb: classes.thumb
                  }}
                  // onChange={(e, value) => {
                  //   const parent = document.getElementById("sliderPhone")
                  //   const elements = Array.from(parent.children).filter(
                  //     x => x.innerHTML
                  //   )
                  //   const selected = options.find(x => x.id === value)
                  //   const selectedElem = elements.find(
                  //     x => x.innerHTML === selected.label
                  //   )
                  //   elements.map(x => {
                  //     x.classList.remove(classes.activeSlider)
                  //   })
                  //   selectedElem.classList.add(classes.activeSlider)

                  //   setFormData({
                  //     target: {
                  //       value: value,
                  //       name: "plan"
                  //     }
                  //   })
                  // }}
                  onChange={(e, val) => changesValuesSlider(val, "sliderPhone")}
                />
              </Box>
            </Box>
          </Form>
        )
      }}
    </Formik>
  )
}

export default withStyles(styles)(Step3OrganizationSize)



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/steps/Step3OrganizationSize/index.jsx